import '~/above-the-fold.css';

import frontEndVars from '~/front-end-vars';
import $ from '~/qwery';
import bean from '~/bean';
import BasketButton from '~/components/basket-button';
import popupManager from '~/components/popup/manager';

import '~/pages/category.js';
import '~/pages/product.js';
import '~/pages/order.js';

const $allButFooter = $('.all-but-footer');
const $siteHeader = $('.b-site-header');
const $h1 = $('h1');
const $basketButton = $('.b-basket-button');
const $footer = $('footer');

$h1.css('max-width', document.body.scrollWidth
    - parseFloat(frontEndVars['left-block-width'])
    - 2 * parseFloat(frontEndVars['page-spacing'])
    - ($basketButton.length ?
        parseFloat(frontEndVars['page-spacing'])
        + $basketButton[0].offsetWidth
    : 0));
if ($basketButton.length)
    new BasketButton($basketButton);

let positionFooter;
if (popupManager.mode() == 'hideViewportScrollbars') {
    positionFooter = (event) => {
        // Why add pageYOffset? Consider user scrolling to the bottom of the page,
        // then opening popup, and enlarging the window vertically.
        // Footer is supposed to stick to bottom.
        const minHeight
            = (popupManager.popupShown() ? popupManager.noPopupPageYOffset() : 0)
            + popupManager.noPopupViewportClientHeight()
            - parseFloat($footer.css('margin-top'))
            - $footer[0].offsetHeight;
        $allButFooter.css('min-height', minHeight > 0 ? minHeight + 'px' : '');
    };
    bean.on(popupManager, 'updateExtents', () => { positionFooter('updateExtents') });
    bean.on(popupManager, 'afterDestroy', () => { positionFooter('afterDestroy') });

} else {
    const minSiteWidth = parseFloat($(document.body).css('min-width'));
    function updateSiteMinWidth(event) {
        if (event == 'updateExtents' && ! popupManager.popupShown())
            return;
        const minWidth = popupManager.popupShown()
            ? Math.max(
                minSiteWidth,
                window.pageXOffset + popupManager.popupBoundingClientRect()['right']
            )
            : 0;
        $(document.body).css('min-width', minWidth ? minWidth + 'px' : '');
    }
    bean.on(popupManager, 'updateExtents', () => { updateSiteMinWidth('updateExtents') });
    bean.on(popupManager, 'afterDestroy', () => { updateSiteMinWidth('afterDestroy') });

    positionFooter = (event) => {
        const minHeight = Math.max(
                document.documentElement.clientHeight,
                popupManager.popupShown() ?
                    window.pageYOffset + popupManager.popupBoundingClientRect()['bottom']
                : 0
            ) - parseFloat($footer.css('margin-top'))
            - $footer[0].offsetHeight;
        $allButFooter.css('min-height', minHeight > 0 ? minHeight + 'px' : '');
    };
    bean.on(popupManager, 'updateExtents', () => { positionFooter('updateExtents') });
    bean.on(popupManager, 'afterDestroy', () => { positionFooter('afterDestroy') });
}
positionFooter('load');
$footer.removeClass('invisible');

bean.on(window, 'keydown', e => {
    if (e.key == 'Tab')
        $(document.body).removeClass('no-focus-outline');
});



// WEBPACK FOOTER //
// ./makosh/assets/index.js